import themeStrategy from '../themeStrategy/themeStrategy.js';
import { TextStyleTransformer } from '../text-style-transformer.js';
import { RicosTextStyle } from '../document-style/text-style.js';
import { RicosNodeStyle } from '../document-style/node-style.js';
import { Decorations } from '../decorations/decorations.js';
import 'react';
import '../themeStrategy/generators/palette.js';
import '../themeUtils-70529429.js';
import '../themeStrategy/generators/identifiers.js';
import '../themeStrategy/palettes/presets.js';
import '../themeStrategy/palettes/wixPaletteUtils.js';
import 'lodash';
import '../themeStrategy/generators/typography.js';
import '../themeStrategy/generators/customStyles.js';
import '../themeStrategy/defaults.js';
import '../utils-398956f3.js';
import 'ricos-content/libs/utils';
import './custom-styles.js';
import './empty-custom-style.js';
import './custom-style.js';
import 'ricos-schema';
import '../decorations/bold-decoration.js';
import '../decorations/empty-decoration.js';
import '../decorations/color-decoration.js';
import '../decorations/font-size-decoration.js';
import '../decorations/italic-decoration.js';
import '../decorations/underline-decoration.js';

class RicosTextualTheme {
  constructor(theme) {
    this.theme = theme;
    this.documentStyle = TextStyleTransformer.fromTheme(this.theme).toDocumentStyle();
  }
  getDecoration(nodeType, decorationType) {
    const textNodeStyle = this.documentStyle[nodeType];
    return Decorations.of((textNodeStyle == null ? void 0 : textNodeStyle.decorations) || []).byType(decorationType);
  }
  getTextStyle(nodeType) {
    var _a;
    return RicosTextStyle.of({ lineHeight: (_a = this.documentStyle[nodeType]) == null ? void 0 : _a.lineHeight });
  }
  getNodeStyle(nodeType) {
    var _a;
    return RicosNodeStyle.of((_a = this.documentStyle[nodeType]) == null ? void 0 : _a.nodeStyle);
  }
  toStyleTag() {
    return themeStrategy({ ricosTheme: this.theme }).html;
  }
  getColors() {
    return themeStrategy({ ricosTheme: this.theme }).themeData.colors || {};
  }
}

export { RicosTextualTheme as default };
//# sourceMappingURL=textual-theme.js.map
